$(function(){
    let headerRating = $('.header-rating'),
        headerRatingStars = $('.header-rating-stars'),
        apiUrl = 'https://api.reviews.io/stats/all?store=jonic-uk.myshopify.com',
        rating = '';

    initHeaderRating();

    async function initHeaderRating() {
        let data,
            rating;

        if (sessionStorage.reviewsIoData) {
            data = JSON.parse(sessionStorage.reviewsIoData)
        } else {
            let json = await getJson(apiUrl);

            sessionStorage.reviewsIoData = json;
            data = JSON.parse(json);
        }

        if (data.company_review_stats.average_rating) {
            rating = data.company_review_stats.average_rating;
        } else if (data.product_review_stats.average_rating) {
            rating = data.product_review_stats.average_rating;
        }

        if (rating) {
            setRating(rating);
        }
    }

    function setRating(rating) {
        let stars = Math.floor(rating),
            fraction = rating - stars,
            star = '<li><span class="star star-full"></span></li>';

        for (let i = 0; i < stars; i++) {
            headerRatingStars.append(star);
        }

        if (fraction > 0) {
            headerRatingStars.append('<li><span class="star" style="width: ' + fraction * 100 + '%"></span></li>');
        }

        setTimeout(function(){
            headerRating.addClass('anim');
        }, 10)
    }

    function getJson(url) {
        return fetch(url)
            .then(response => response.text())
            .then(function (json) {
                return json;
            });
    }
})